import api from "./apiURL";
export async function getUserListDetails() {
  try {
    const response = await api.get(`/api/v1/admin/user/getAll`);
    return response.data;
  } catch (error) {
    console.log(error);
  }
}

export async function getUserProfile(userId) {
  try {
    const response = await api.get(`/api/v1/admin/user/view/?id=${userId}`);
    return response.data;
  } catch (error) {
    console.log("Error fetching user profile:", error);
  }
}

export async function addLeads(data) {
  try {
    const response = await api.post(`/api/v1/admin/leads/add`, data);
    return response.data;
  } catch (error) {
    console.log("Error fetching user profile:", error);
  }
}


export async function getLeads() {
  try {
    const response = await api.get(`/api/v1/admin/leads/get`);
    return response.data;
  } catch (error) {
    console.log("Error fetching user profile:", error);
  }
}
